var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('div',{attrs:{"id":"app"}},[_c('Header'),_c('router-view'),_c('vue-confirm-dialog')],1),_c('v-footer',{attrs:{"app":""}},[_c('Snackbar')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }